import AssetDetail from './AssetDetail';
export default AssetDetail;
